import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="none"
          viewBox="0 0 14 14"
        >
          <path d="M12.4 10.889H1.6c-.331 0-.6.249-.6.555 0 .307.269.556.6.556h10.8c.331 0 .6-.249.6-.556 0-.306-.269-.555-.6-.555zM1.6 3.11h10.8c.331 0 .6-.249.6-.555 0-.307-.269-.556-.6-.556H1.6c-.331 0-.6.249-.6.556 0 .306.269.555.6.555zm10.8 3.333H1.6c-.331 0-.6.25-.6.556 0 .307.269.556.6.556h10.8c.331 0 .6-.25.6-.556 0-.307-.269-.556-.6-.556z"></path>
        </svg>
    );
}